export const billingConstants = {
    GET_BILLING_SETTINGS_REQUEST: 'GET_BILLING_SETTINGS_LINK_REQUEST',
    GET_BILLING_SETTINGS_SUCCESS: 'GET_BILLING_SETTINGS_LINK_SUCCESS',
    GET_BILLING_SETTINGS_FAILURE: 'GET_BILLING_SETTINGS_LINK_FAILURE',

    GET_BILLING_SUMMARY_REQUEST: 'GET_BILLING_SUMMARY_REQUEST',
    GET_BILLING_SUMMARY_SUCCESS: 'GET_BILLING_SUMMARY_SUCCESS',
    GET_BILLING_SUMMARY_FAILURE: 'GET_BILLING_SUMMARY_FAILURE',

    GET_ORGANIZATION_BILLINGS_REQUEST: 'GET_ORGANIZATION_BILLINGS_REQUEST',
    GET_ORGANIZATION_BILLINGS_SUCCESS: 'GET_ORGANIZATION_BILLINGS_SUCCESS',
    GET_ORGANIZATION_BILLINGS_FAILURE: 'GET_ORGANIZATION_BILLINGS_FAILURE',
};
